import { Form } from 'antd';
import React from 'react';
import { CurrencyInput } from '@common/components';

const rules = [{ required: true, message: 'Please enter a billing rate' }];
const style = { width: '84px' };

export const DisputeBillingRateInput = ({
  disabled,
  onSetRateCents,
}: {
  disabled: boolean;
  onSetRateCents: () => void;
}) => {
  return (
    <>
      <Form.Item name="finalRateCents" rules={rules}>
        <CurrencyInput
          size="large"
          className="dispute-billing-rate-input"
          min={0}
          style={style}
          disabled={disabled}
          onKeyUp={onSetRateCents}
        />
      </Form.Item>
      <style jsx>
        {`
          :global(.dispute-billing-rate-input .ant-input-number-handler-wrap) {
            display: none;
          }
        `}
      </style>
    </>
  );
};
